import { useMobile } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';
import { Card } from 'reactstrap';

interface Props {
  onlineAttendance: number | null;
}

export default function OnlineSummaryCard({ onlineAttendance }: Props) {
  const { t } = useTranslation();
  const prefix = 'studentAttendance';

  const isMobile = useMobile();

  return (
    <Card
      className="bg-transparent border border-primary px-4 py-3 d-flex flex-column"
      style={{
        width: isMobile ? '100%' : 345,
        alignSelf: 'stretch',
      }}
    >
      <h2 className="text-secondary fs-20 fw-600 ">
        {t(`common.terms.onlineAttendance`)}
      </h2>
      <div
        className="d-flex flex-column align-items-center justify-content-center py-4 px-3 flex-fill w-100"
        style={{
          background: '#F7F7F7',
        }}
      >
        <h3 className="text-primary mb-1" style={{ fontSize: 35 }}>
          {Number(onlineAttendance ?? 0 / 100).toLocaleString('es-CL', {
            style: 'percent',
          })}
        </h3>
        <p className="mb-0 fs-12">{t(`${prefix}.totalAttendance`)}</p>
      </div>
      {onlineAttendance === null && (
        <p className="text-warning fs-12 mb-0 text-center">
          {t(`${prefix}.requiredOnlineAssistance`)}
        </p>
      )}
    </Card>
  );
}
